<template>
    <b-button variant="gray-secondary" size="lg" class="mr-3" @click="onCancel">
        <span>Cancel</span>
    </b-button>
</template>

<script>
export default {
    methods: {
        onCancel() {
            this.$emit("cancel");
        },
    },
};
</script>
